export default [
  {
    group: 'Geral',
    fields: [
      {
        class: 'col-12',
        type: 'text',
        field: 'nome',
        label: 'Nome',
        maxlength: 500,
        rules: ['required']
      },
      {
        class: 'col-12',
        type: 'text',
        field: 'email',
        label: 'Email',
        maxlength: 500,
        rules: ['required']
      },
      {
        class: 'col-md-6',
        type: 'text',
        field: 'usuario',
        label: 'Usuário',
        maxlength: 500,
        rules: ['required']
      },
      {
        class: 'col-md-6',
        type: 'password',
        field: 'senha',
        label: 'Senha',
        maxlength: 500,
        rules: [] // Será obrigatório apenas se tipo_auth for 'senha'
      },
      {
        class: 'col-12',
        type: 'select-tipo',
        field: 'tipo',
        label: 'Serviços Vinculados',
        tipo: 32,
        multiple: true,
        info: 'Selecione os serviços que utilizarão essa conta de email',
        rules: ['']
      }
    ]
  },
  {
    group: 'Tipo de Autenticação',
    fields: [
      {
        class: 'col-12',
        type: 'select-tipo',
        field: 'tipo_auth',
        label: 'Método de Autenticação',
        tipo: 241, // Vai usar sua tabela tipo
        valor: 'valor', // Campo valor da sua tabela
        info: 'OAuth2 oferece maior segurança e melhor entrega de emails',
        rules: ['required']
      }
    ]
  },
  {
    group: 'Configurações SMTP',
    fields: [
      {
        class: 'col-md-6',
        type: 'text',
        field: 'servidor_smtp',
        label: 'Servidor SMTP',
        maxlength: 500,
        info: 'Servidor STMP do seu provedor. Exemplo: smtp.gmail.com, stmp.google.com, etc',
        rules: [] // Será obrigatório apenas se tipo_auth for 'senha'
      },
      {
        class: 'col-md-3',
        type: 'text',
        field: 'porta',
        label: 'Porta',
        maxlength: 500,
        info: 'A maioria dos servidores utilizam a porta 587. Na dúvida entre em contato com seu provedor para saber qual a porta de autenticação.',
        rules: [] // Será obrigatório apenas se tipo_auth for 'senha'
      },
      {
        class: 'col-md-3',
        type: 'boolean',
        field: 'autenticacao',
        label: 'Seu servidor requer autenticação?',
        info: 'A maioria dos servidores requerem autenticação. É recomendado que deixe esse campo habilitado.',
        rules: [] // Será obrigatório apenas se tipo_auth for 'senha'
      },
      {
        class: 'col-12',
        type: 'select-tipo',
        field: 'conexao_seg',
        tipo: 240,
        valor: 'valor',
        label: 'Seu Servidor Requer uma Conexão de Segurança?',
        info: 'A maioria dos servidores requerem autenticação TLS.',
        rules: [] // Será obrigatório apenas se tipo_auth for 'senha'
      }
    ]
  },
  {
    group: 'Configurações Avançadas',
    fields: [
      {
        class: 'col-12',
        type: 'number',
        field: 'tempo_espera',
        label: 'Tempo de Espera (Segundos)',
        info: 'Recomenda-se deixar 0 (zero)',
        rules: ['required']
      },
      {
        class: 'col-12',
        type: 'number',
        field: 'n_msg_pct',
        label: 'MARKETING - Nº Mensagens por Pacote',
        info: 'Recomenda-se deixar 50',
        rules: ['required']
      },
      {
        class: 'col-12',
        type: 'number',
        field: 't_esp_pct',
        label: 'MARKETING - Tempo espera entre Pacote(s)',
        info: 'Recomenda-se deixar 600',
        rules: ['required']
      }
    ]
  }
];


// WEBPACK FOOTER //
// ./src/components/apps/web/conta-email/_form/email-cadastrar.js